import { Link } from 'react-router-dom';
import { hotTags } from '@/mocks/site-config';
import { latestArticles } from '@/mocks/home-data';

export default function BottomGrid() {
  const articles = latestArticles.slice(4, 8);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-2/3">
            <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950 mb-6">
              持续追踪
            </h2>
            <div className="space-y-4">
              {articles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="flex gap-4 p-4 rounded-xl bg-background-50 cursor-pointer group transition-all duration-200 hover:-translate-x-1"
                >
                  <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-[10px] font-semibold text-foreground-400">{index + 1}</span>
                      <span className="text-[10px] text-primary-500 font-medium">{article.categoryName}</span>
                      {article.isNew && (
                        <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] font-semibold rounded whitespace-nowrap">
                          NEW
                        </span>
                      )}
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-400 line-clamp-1">{article.excerpt}</p>
                    <div className="flex items-center gap-3 mt-2 text-[11px] text-foreground-400">
                      <span>{article.date}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line" />
                        {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views.toLocaleString()}
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/3">
            <div className="sticky top-24">
              <h2 className="font-heading text-xl md:text-2xl font-black text-foreground-950 mb-6">
                热门标签
              </h2>
              <div className="flex flex-wrap gap-2">
                {hotTags.map((tag) => (
                  <Link
                    key={tag}
                    to={`/category/hot`}
                    className="px-4 py-2 bg-background-50 text-foreground-600 text-sm rounded-full hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    #{tag}
                  </Link>
                ))}
              </div>

              <div className="mt-8 p-5 rounded-xl bg-primary-50/50 border border-primary-100/50">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-notification-3-line text-primary-500 text-lg" />
                  <h3 className="font-heading text-sm font-bold text-foreground-950">爆料投稿</h3>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                  你有独家爆料线索？欢迎向我们投稿！一经采用，丰厚稿酬等你拿。严格保护爆料人隐私。
                </p>
                <Link
                  to="/about"
                  className="inline-flex items-center gap-1.5 text-xs font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  了解投稿方式
                  <i className="ri-arrow-right-line text-xs" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}